import React, { useRef, useState } from "react";
import CustomButton from "../CustomButton/CustomButton";
import { MdAddCircle } from "react-icons/md";
import { warnToast } from "../../../utils/toasts";
import CLabel from "../CLabel";
import { useField } from "formik";
import FileInputBasic from "./FileInputBasic";
import Text from "../../typography/Text";

const FileInput = ({
  variant = "traditional",
  buttonVariant = "outlined",
  label = "Upload File",
  setSelectedFiles = () => {},
  icon = null,
  accept = "image/*",
  size = 0,
  sizeVariant = "MB",
  name = null,
  multipleFiles= false,
  inputLabel ="",
  clearFiles,
  fileName=null,
  fileType="all",
}) => {
  const [field, meta] = useField(name);
  const isError = meta.touched && meta.error;
  return (
    <div className="flex flex-col gap-1">
      <Text className="!text-sm !font-medium">{inputLabel}</Text>
      <FileInputBasic
        variant={variant}
        buttonVariant={buttonVariant}
        label={label}
        setSelectedFiles={setSelectedFiles}
        icon={icon}
        accept={accept}
        size={size}
        sizeVariant={sizeVariant}
        {...field}
        name={name}
        multipleFiles={multipleFiles}
        clearFiles={clearFiles}
        fileName={fileName}
        fileType={fileType}
      />
      {isError && <CLabel error label={meta.error} />}
    </div>
  );
};

export default FileInput;
